var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdsSuccess2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 208,
    viewBox: "0 0 183 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.32 125.8L72.2173 204.194L89.1548 191.622L106.932 203.258L101.389 125.8L81.32 125.8Z",
    fill: "#009846"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.389 125.632L101.696 129.888L80.8478 129.888L81.3159 125.803L101.389 125.632Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3326 125.523C83.631 141.847 82.2994 158.143 80.3274 174.363C81.024 158.039 82.3653 141.744 84.3326 125.523Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5302 124.117C100.632 141.043 101.106 158.01 100.935 174.972C99.8272 158.045 99.3632 141.079 99.5302 124.117Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8012 124.832C92.1017 141.652 91.7716 158.483 90.7979 175.279C90.4923 158.458 90.8318 141.627 91.8012 124.832V124.832Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7643 124.465C96.365 141.509 96.3357 158.574 95.6621 175.615C95.0565 158.572 95.095 141.506 95.7643 124.465Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0352 125.181C87.7797 142.014 86.8937 158.838 85.3652 175.604C85.6159 158.771 86.5113 141.948 88.0352 125.181V125.181Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0379 39.3388C60.0379 39.3388 73.3469 8.36204 91.1355 8.36206C116.898 8.36209 122.911 42.7125 122.911 42.7125C122.911 42.7125 139.966 52.4478 139.468 83.7484C139.054 109.787 115.219 127.454 91.1355 127.048C72.6398 126.737 46.059 116.469 41.9799 90.5592C37.9005 64.6489 60.0379 39.3388 60.0379 39.3388Z",
    fill: "#009846"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.134 113.018C97.3472 111.232 98.4196 116.229 99.2374 118.319C100.168 120.697 100.924 121.808 102.561 122.052",
    stroke: "#263138",
    strokeWidth: 1.73775,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.208 113.035C107.572 111.172 106.594 116.383 105.849 118.562C105 121.041 104.311 122.199 102.818 122.454",
    stroke: "#263138",
    strokeWidth: 1.73775,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.437 113.01C111.073 111.264 110.259 116.149 109.637 118.191C108.931 120.516 108.356 121.602 107.112 121.841",
    stroke: "#263138",
    strokeWidth: 1.73775,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6905 113.018C67.904 111.232 68.9764 116.229 69.7942 118.319C70.7243 120.697 71.4812 121.808 73.1182 122.052",
    stroke: "#263138",
    strokeWidth: 1.73775,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4101 113.138C71.624 111.352 72.6963 116.349 73.5138 118.439C74.4442 120.816 75.2007 121.927 76.8378 122.171",
    stroke: "#263138",
    strokeWidth: 1.73775,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9936 113.01C81.6301 111.264 80.8154 116.149 80.1941 118.191C79.4874 120.516 78.9124 121.602 77.6687 121.841",
    stroke: "#263138",
    strokeWidth: 1.73775,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.367 42.7113C123.367 42.7113 123.685 45.4189 123.367 64.7937C123.103 80.9275 102.676 87.3795 87.3233 87.1285C71.7812 86.8744 58.3895 75.9934 58.6573 59.6454C58.8327 48.9363 56.8501 46.1402 59.5734 39.951C62.9471 32.2835 64.1739 31.6702 64.1739 31.6702C66.0141 27.3763 69.2864 23.0688 73.6816 18.1753C77.1638 14.2983 80.8891 9.84523 87.4832 8.66767C104.658 5.60055 114.779 22.4692 114.779 22.4692C114.779 22.4692 116.313 23.6959 117.54 27.3763C120.3 32.5902 119.459 30.9066 120.913 34.7371C122.369 38.5709 123.367 42.7113 123.367 42.7113Z",
    fill: "white",
    fillOpacity: 0.301961
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3 34.4313C121.527 38.7251 125.207 45.1658 115.086 49.4596C106.192 52.2199 111.627 46.3926 93.8385 46.3926C74.8231 45.4725 80.8802 50.6864 69.6092 47.6194C63.826 46.0457 64.4805 30.7509 64.4805 30.7509L68.1609 24.6926C68.1609 24.6926 73.5587 18.8935 80.8802 18.7896L105.046 19.1847C115.02 19.3478 119.073 30.1375 120.3 34.4313Z",
    fill: "white",
    fillOpacity: 0.501961
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.253 40.2255L91.9353 34.7385L83.8027 40.2255L91.9353 51.607L100.253 40.2255Z",
    fill: "#263138"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5245 32.058C100.56 28.9882 105.854 24.6905 110.74 32.058",
    stroke: "black",
    strokeWidth: 2.4628
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6017 32.058C76.6375 28.9882 81.9307 24.6905 86.8168 32.058",
    stroke: "black",
    strokeWidth: 2.4628
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1052 78.5519L1.09787 10.6683C1.09787 10.6683 30.1197 19.086 42.9618 35.8484C59.2908 57.1622 53.1052 78.5519 53.1052 78.5519V78.5519Z",
    fill: "#009846"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1052 78.5519L1.09787 10.6683C1.09787 10.6683 30.1197 19.086 42.9618 35.8484C59.2908 57.1622 53.1052 78.5519 53.1052 78.5519V78.5519Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1786 19.4756C22.8257 19.8222 23.4805 20.1784 24.1333 20.5526C32.521 31.4178 40.8176 42.4961 48.4929 53.0965C39.8471 42.4129 30.8728 30.9485 22.1786 19.4756Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 15.5074C14.5094 15.7368 15.0193 15.9661 15.5466 16.1977C25.7178 29.2249 35.9292 42.7612 45.2252 55.6007C34.9363 42.9183 24.1941 29.1047 13.9997 15.5074Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6591 12.5484C7.00358 12.6661 7.36354 12.8034 7.73109 12.9511C19.4012 27.7064 31.2745 43.3704 41.9473 58.1112C30.301 43.7194 18.0347 27.8952 6.6591 12.5484V12.5484Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M125.905 80.5009L181.507 15.5291C181.507 15.5291 152.073 22.365 138.343 38.4085C120.885 58.8079 125.905 80.5009 125.905 80.5009V80.5009Z",
    fill: "#009846"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M125.905 80.5009L181.507 15.5291C181.507 15.5291 152.073 22.365 138.343 38.4085C120.885 58.8079 125.905 80.5009 125.905 80.5009V80.5009Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M159.981 23.1835C159.316 23.4947 158.643 23.8149 157.971 24.1532C149.008 34.5489 140.124 45.1623 131.887 55.3322C141.098 45.1318 150.679 34.1695 159.981 23.1835Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M168.362 19.6617C167.841 19.8632 167.319 20.0646 166.78 20.2673C155.92 32.7253 144.991 45.6897 135.014 58.0076C145.974 45.9003 157.448 32.6878 168.362 19.6617Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M175.852 17.105C175.502 17.2039 175.135 17.3216 174.76 17.4492C162.309 31.5517 149.606 46.5507 138.152 60.6928C150.559 46.9519 163.663 31.8141 175.852 17.105V17.105Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_419_4856)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.179,
    cy: 37.192,
    rx: 10.4278,
    ry: 3.067,
    fill: "#FFBFE1",
    fillOpacity: 0.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_419_4856)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.9884,
    cy: 36.5777,
    rx: 10.4278,
    ry: 3.067,
    fill: "#FFBFE1",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_419_4856",
    x: 97.2884,
    y: 31.6622,
    width: 25.7812,
    height: 11.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2314,
    result: "effect1_foregroundBlur_419_4856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_419_4856",
    x: 61.0978,
    y: 31.0479,
    width: 25.7812,
    height: 11.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2314,
    result: "effect1_foregroundBlur_419_4856"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdsSuccess2);
export default __webpack_public_path__ + "static/media/birds_success2.fb842bd865fa4035381fefa58d49c1b2.svg";
export { ForwardRef as ReactComponent };